import React from "react";
import { isNotificationNavigationBlocked } from "./notifications";
import notificationIcon from "../../assets/images/notification.svg";
import closeIcon from "../../assets/images/closeIcon.svg";
import { useT } from "../../i18n/useT";

const CATEGORY_COLORS = {
  CRITICAL: "#E53E3E",
  RISK_STATUS: "#B83280",
  SENSOR_DATA: "#054997",
  STATUS_CHANGE: "#F9A021",
  GENERAL_UPDATE: "#53AC82",
  SYSTEM: "#054997",
};

const formatAction = (action, t) => {
  const cleaned = String(action || "").replace(/^SEE_/i, "");
  const words = cleaned.split(/[_\s]+/).filter(Boolean);
  return words.length
    ? t("see_action", {
        action: words
          .map((word) => word[0] + word.slice(1).toLowerCase())
          .join(" "),
      })
    : "";
};

export default function NotificationTimelineDrawer({
  open,
  timeline,
  loading,
  onClose,
  onNotificationPress,
}) {
  const t = useT("mmtUserList");

  return (
    <div
      className={`mmt-drawer-overlay ${open ? "is-open" : ""}`}
      aria-hidden={!open}
    >
      <button
        className="mmt-drawer-backdrop"
        onClick={onClose}
        aria-label={t("close_notifications")}
      />
      <aside className="mmt-timeline-drawer">
        <button
          className="mmt-drawer-close"
          onClick={onClose}
          aria-label={t("close")}
        >
          <img src={closeIcon} alt="" />
        </button>
        <h2>{t("notifications")}</h2>
        <div className="mmt-drawer-divider" />
        {loading ? (
          <div className="mmt-drawer-empty">{t("loading")}</div>
        ) : timeline.length ? (
          <div className="mmt-timeline-list">
            {timeline.map((item) => {
              const color = CATEGORY_COLORS[item.category] || "#4d4e50";
              const parts = String(item.message || "").split(" – ");
              const quickJumpLabel = item.quickJump?.action
                ? formatAction(item.quickJump.action, t)
                : item.quickJump?.destination
                  ? formatAction(item.quickJump.destination, t)
                  : "";
              const isPressable =
                !isNotificationNavigationBlocked(item) &&
                !!(item.openUrl || item.quickJump);
              return (
                <button
                  key={item.id || `${item.message}-${item.time}`}
                  className={`mmt-timeline-item ${isPressable ? "is-pressable" : ""}`}
                  onClick={() => isPressable && onNotificationPress(item)}
                  disabled={!isPressable}
                >
                  <span
                    className="mmt-category-bar"
                    style={{ backgroundColor: color }}
                  />
                  <span className="mmt-timeline-row">
                    <span className="mmt-timeline-icon">
                      <img src={item.iconURL || notificationIcon} alt="" />
                    </span>
                    <span className="mmt-timeline-copy">
                      <span className="mmt-category-label" style={{ color }}>
                        {t(
                          `categories.${String(
                            item.category || "GENERAL",
                          ).toLowerCase()}`,
                        )}
                      </span>
                      <strong className={!item.isRead ? "is-unread" : ""}>
                        {parts[0] || item.title || "Senior Life"}
                      </strong>
                      <span>{`${parts[1] || item.title || item.message || ""}${item.sourceTool ? ` (${item.sourceTool})` : ""}`}</span>
                      {isPressable && quickJumpLabel ? (
                        <em>{quickJumpLabel}</em>
                      ) : null}
                    </span>
                  </span>
                  <small>{item.time}</small>
                </button>
              );
            })}
          </div>
        ) : (
          <div className="mmt-drawer-empty">{t("no_notifications")}</div>
        )}
      </aside>
    </div>
  );
}
